import { FC, HTMLAttributes, Ref } from "react";
import { ListboxKeepTyping } from "constants/text";
import {
	ListboxContainer,
	ListboxHeader
} from "pages/Replacements/components/AddNewAddressModal/addNewAddressModal.styles";

const ListboxComponent: FC<HTMLAttributes<HTMLElement> & { ref?: Ref<HTMLDivElement> }> = function ListboxComponent({
	ref,
	...props
}) {
	return (
		<div ref={ref}>
			<ListboxContainer>
				<ListboxHeader>{ListboxKeepTyping}</ListboxHeader>
			</ListboxContainer>
			<ul {...props} />
		</div>
	);
};

export default ListboxComponent;
